import { makeStyles } from "@material-ui/core/styles";
export const PaymentGateWayCss = makeStyles(theme => ({
    paper: {
        borderRadius: 4,
        minWidth: '700px !important',
        //width:800
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    dialogContent: {
        padding:0
    },
    dialogTitle: {
        padding:'16px 24px',
        "& .MuiTypography-root": {
            display: 'flex',
            justifyContent: 'space-between'
        }
    },
    dot: {
        fontSize: 10,
        color: 'rgba(11, 19, 35, 0.75)',
        margin:'0 8px'
    },
    iconBox:{
        width:50,
        height:50,
        borderRadius:4,
        padding:9,
        marginRight:16,
        textAlign:'center'
    },
    icon:{
        fontSize:32
    },
    walletIcon:{
        fontSize:40
    },
    paymentTitle:{
        fontSize:18,
        color:'#0b1323',
        fontWeight:600,
        marginBottom:2
    },
    walletPaymentTitle:{
        fontSize:14,
        color:'#03c',
        fontWeight:600,
        marginBottom:2
    },
    accountNumber:{
        color:'rgba(11, 19, 35, 0.75)',
        fontSize:16
    },
    payTo:{
        color:'#0b1323',
        fontSize:16,
        fontWeight:600,
        marginLeft:80,
        display:'flex',
        alignItems:'center'
    },
    rechargeTo:{
        color:'#0b1323',
        fontSize:16,
        fontWeight:600,
        display:'flex',
        alignItems:'center'
    },
    payByWallet:{
        color:'#0b1323',
        fontSize:16,
        fontWeight:600,
        display:'flex',
        alignItems:'center'
    },
    amountPay:{
        color:'#03c',
        fontSize:20,
        fontWeight:600
    },
    payFromWalletBox:{
        width:'100%',
        padding:'16px 32px',
        backgroundColor:'#e6f4fe'
    },
    paymentBox:{
        flexGrow: 1,
        backgroundColor: '#fff',
        display: 'flex',
        height: 466,
        padding:16
    },
    addNewUPIBox:{
        padding:16,
        border: 'solid 1px #dedede',
        borderRadius:4
    },
    UPIListBox:{
        padding:16,
        border: 'solid 1px #dedede',
        borderRadius:4,
        marginBottom:12
    },
    addNewUPIBoxSelected:{
        cursor:'pointer',
        padding:16,
        border: 'solid 1px #43b18d',
        borderRadius:4,
        backgroundColor: 'rgba(0, 135, 90, 0.05)'
    },
    UPIListBoxSelected:{
        cursor:'pointer',
        padding:16,
        border: 'solid 1px #43b18d',
        borderRadius:4,
        marginBottom:12,
        backgroundColor: 'rgba(0, 135, 90, 0.05)'
    },
    addBtnNormal:{
        color:'#e8ebf0',
        fontSize:32,
        marginRight:20
    },
    addBtnSelected:{
        color:'#d6efe8',
        fontSize:32,
        marginRight:20
    },
    addNewUpiTxt:{
        fontSize:16,
        fontWeight:600,
        color:'#0b1323'
    },
    brandLogoIcon:{
        fontSize:16,
        marginRight:12
    },
    label:{
        color:'rgba(11, 19, 35, 0.75)',
        fontSize:14,
        marginBottom:4
    },
    inputUpi:{
        color:'rgba(11, 19, 35, 0.5)',
        '& .MuiOutlinedInput-input':{
            borderRadius:4,
            border:'1px solid #dedede'
        }
    },
    verifyAddBtn:{
        marginLeft:8,
        padding:'16px 24px',
        textTransform:'capitalize',
        borderRadius:4,
        backgroundColor:'#00875a',
        color:'#fff',
        '&:hover': {
            backgroundColor: '#00875a',
        }
    },
    verifyAddBtnSelected:{
        marginLeft:8,
        width:160,
        padding:'16px 24px',
        textTransform:'capitalize',
        borderRadius:4,
        backgroundColor:'#00875a',
        color:'#fff',
        '&:hover': {
            backgroundColor: '#00875a',
        }
    },
    knowToFind:{
        fontSize:14,
        color:'#0b1323',
        marginRight:24
    },
    nextIcon:{
        color:'#dedede'
    },
    payBtn:{
        width:'100%',
        paddingTop:14,
        paddingBottom:14,
        textTransform:'capitalize',
        borderRadius:4,
        backgroundColor:'#03c',
        color:'#fff',
        '&:hover': {
            backgroundColor: '#03c',
        }
    },
    menuIcon:{
        marginRight:16
    },
    vpa:{
        fontSize:16,
        fontWeight:600,
        color:'#0b1323'
    },
    selected:{
        fontSize:16,
        color:'#43b18d'
    },
    unselected:{
        fontSize:16,
        color:'#b8b8ba'
    },
    nbBox:{
        borderRadius: 4,
        border: 'solid 1px #dedede',
        backgroundColor:'#fff',
        padding:'12px 16px'
    },
    nbBoxSelected:{
        borderRadius: 4,
        border: 'solid 1px #dedede',
        backgroundColor:'rgba(0, 135, 90, 0.05)',
        padding:'12px 16px'
    },
    bankName:{
        color:'#0b1323',
        fontSize:16,
        fontWeight:600,
        marginRight:18
    },
    inputSelect:{
        '& .MuiInputLabel-shrink': {
            content:''
        }  
    },
    labelSelect:{
        color:'#0b1323',
        opacity:1 
    },
    nbItem:{
        minWidth:258
    },
    helperText:{
        marginLeft:0
    }
}));